import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'components/Collapsible';
import { formatNumber } from 'utils/formatting';
import './CollapsibleCurrencyCard.css';

const CollapsibleCurrencyCard = ({
  className,
  currencyType,
  currencyTotalValue,
  data
}) => {
  return (
    <div className={`dynamic-currency-card`}>
      <div className={`currency-card ${className}`}>
        <Collapsible>
          <div className="currency-info-container">
            <div className="currency-name">{currencyType}</div>
            <div className="currency-value-with-toggle">
              {currencyTotalValue}
              {data?.length > 0 ? (
                <Collapsible.Toggle className="currency-card-toggle" />
              ) : null}
            </div>
          </div>
          <Collapsible.Content className="currency-content">
            <div className="outer-content-block-container">
              <div className="inner-content-scrollable-container">
                {data?.map((item, index) => (
                  <div className={`currency-item-info-${index}`} key={index}>
                    <div>{item.name}</div>
                    <div>{formatNumber(item.amount)}</div>
                  </div>
                ))}
              </div>
            </div>
          </Collapsible.Content>
        </Collapsible>
      </div>
    </div>
  );
};

CollapsibleCurrencyCard.propTypes = {
  className: PropTypes.string,
  currencyType: PropTypes.string.isRequired,
  currencyTotalValue: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired
    })
  ).isRequired
};

export default CollapsibleCurrencyCard;
